const PREFIX = "ADMINISTRATOR";

export class SAVE_LOGIN_ALERT {
  public static readonly type = `[${PREFIX}] SAVE LOGIN ALERT`;
  constructor(public readonly payload) {}
}

export class GET_ALERT_HISTORY_LIST {
  public static readonly type = `[${PREFIX}] GET ALERT HISTORY LIST`;
  constructor(public readonly payload) {}
}

export class SET_LOGIN_ALERT_ARCHIVED {
  public static readonly type = `[${PREFIX}] SET LOGIN ALERT ARCHIVED`;
  constructor(public readonly payload) {}
}

export class RESET_LOGIN_ALERT_STATE {
  public static readonly type = `[${PREFIX}] RESET LOGIN ALERT STATE`;
}
export class RESET_EMERGENCY_ALERT_STATE {
  public static readonly type = `[${PREFIX}] RESET EMERGENCY ALERT STATE`;
}
export class UPDATE_EMERGENCY_ALERT {
  public static readonly type = `[${PREFIX}] UPDATE EMERGENCY ALERT`;
  constructor(public readonly payload) {}
}

export class UPDATE_LOGIN_ALERT {
  public static readonly type = `[${PREFIX}] UPDATE LOGIN ALERT`;
  constructor(public readonly payload) {}
}
export class GET_E_ALERT_HISTORY_LIST {
  public static readonly type = `[${PREFIX}] GET E ALERT HISTORY LIST`;
  constructor(public readonly payload) {}
}
export class SAVE_EMERGENCY_ALERT {
  public static readonly type = `[${PREFIX}] SAVE EMERGENCY ALERT`;
  constructor(public readonly payload) {}
}

export class SET_EMERGENCY_ALERT_ARCHIVED {
  public static readonly type = `[${PREFIX}] SET LOGIN ALERT ARCHIVED`;
  constructor(public readonly payload) {}
}
